import { Stack } from '@mui/material';
import { autobind } from 'core-decorators';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Container from '/@/components/container';
import Spinner from '/@/components/spinner';
import { useFieldById } from '/@/hooks/fields';
import { _ } from '/@/locale';
import { isPhone } from '/@/utils';
import Title from '/@/v3/components/title';
import FieldDetail from '/@/views/fields/field-detail';
import FieldInfo from '../../components/field-info-v2';
import WeatherComponent from '../fields/field-detail/field-weather';
import styles from './styles.module.css';

@connect((state, props) => {
    return {
        fieldId: props.fieldId,
    };
})
@autobind
class Weather extends Component {
    render() {
        return (
            <Fragment>
                {!isPhone() ? (
                    <div className={styles.root}>
                        <FieldDetail fieldId={this.props.fieldId} view='weather' isList />
                    </div>
                ) : (
                    <Container className={styles.container}>
                        <div>
                            <Title color={'primary-corn'} size='xl' bolder className={styles.title}>
                                {_('Clima')}
                            </Title>
                            <FieldInfo field={this.props.field} view='weatherPhone' />
                        </div>
                        <WeatherComponent fieldId={this.props.fieldId} view='weatherPhone' />
                    </Container>
                )}
            </Fragment>
        );
    }
}

const WeatherWrapper = (props: any) => {
    const fieldQuery = useFieldById({ id: props.fieldId }, { enabled: props.fieldId });
    if (fieldQuery.isValidating)
        return (
            <Stack justifyContent='center' alignItems='center'>
                <Spinner />;
            </Stack>
        );
    return <Weather {...props} field={fieldQuery.data} />;
};

export default WeatherWrapper;
